import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import arrow from 'common/assets/arrow-select-black.svg';
import styles from './styles.module.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)'
  }
};

const ModalTabuYashirRequestDone = ({
                                      isOpen,
                                      close,
                                      dataURI,
                                      onApprove,
                                      closeAreYouSureModal,
                                    }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(2);
  const [zoom, setZoom] = useState(1);
  const canvas = useRef();

  const countPages = pdf => setTotalPages(pdf.numPages);
  const nextPage = () => setPageNumber(prevState => (prevState <= totalPages) ? prevState + 1 : prevState);
  const prevPage = () => setPageNumber(prevState => (prevState >= 1) ? prevState - 1 : prevState);

  const zoomIn = () => setZoom(prevState => (prevState <= 5) ? prevState + 0.25 : prevState);
  const zoomOut = () => setZoom(prevState => (prevState >= 0.25) ? prevState - 0.25 : prevState);

  const addNewClassToCanvas = () => canvas.current.classList.add(styles.canvas);

  const handleApprove = () => {
    onApprove(dataURI);
    close();
    closeAreYouSureModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={close}
    >
      <div className={styles.serverRequestModalContent}>
        <h2 className={styles.header}>אנא אשרו את המסמך הבא:</h2>
        <div className={styles.documentContainer}>
          <Document
            file={{url: dataURI}}
            className={styles.document}
            onLoadSuccess={countPages}
          >
            <Page
              pageNumber={pageNumber}
              scale={zoom}
              className={styles.page}
              canvasRef={canvas}
              onRenderSuccess={addNewClassToCanvas}
            />
          </Document>
          <div className={`${styles.arrow} ${styles.next}`} onClick={nextPage}>
            <img src={arrow} alt="next"/>
          </div>
          <div className={`${styles.arrow} ${styles.prev}`} onClick={prevPage}>
            <img src={arrow} alt="prev"/>
          </div>
          <div className={`${styles.zoom} ${styles.in}`} onClick={zoomIn}>
            <span>+</span>
          </div>
          <div className={`${styles.zoom} ${styles.out}`} onClick={zoomOut}>
            <span>-</span>
          </div>
          {/*<a href={dataURI} className={styles.open} target="_blank"
             rel="noreferrer">
            <span>פתח בחלון נפרד</span>
          </a>*/}
        </div>
        <p>Page {pageNumber} of {totalPages}</p>
        <div className={styles.modalButtons}>
          <div className={styles.buttonSubmit} onClick={handleApprove}>
            אישור
          </div>
          <div
            className={styles.buttonCancel}
            onClick={() => {
              close();
              closeAreYouSureModal();
            }}
          >
            ביטול
          </div>
        </div>
      </div>
    </Modal>
  );
};

ModalTabuYashirRequestDone.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  dataURI: PropTypes.string,
};

export default ModalTabuYashirRequestDone;
